/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  ScatterController,
  Title,
  Tooltip,
} from "chart.js";
import { Component, Prop, Ref, Vue } from "vue-property-decorator";
@Component
export default class ScatterGraph extends Vue {
  @Prop() options?: any;
  @Ref("canvas") canvas!: HTMLCanvasElement;
  @Prop() chartData?: any;
  mounted(): void {
    const c = this.canvas.getContext("2d");
    Chart.register(ScatterController, LineElement, PointElement, LinearScale, Title);
    Chart.register(CategoryScale, Tooltip, Legend);
    Chart.defaults.font.family = getComputedStyle(document.body).fontFamily;
    Chart.defaults.color = "#161616";

    if (c) {
      const myChart = new Chart(c, {
        type: "scatter",
        data: this.chartData,
        options: this.options,
      });
    }
  }
}
